<template>
    <div id="header">
      <div class="header-wrapper">
      <nav>
        <div class="mobile-header">
        <a :href="`${url}${langPara}${linkTracker}`" class="logo" target="_blank" rel="noopner">
          <img src="../assets/splashtop-logo.svg" alt="Splastop" />
        </a>
        <div class="hambuger-logo" @click="open = !open">
          {{ $t('menuText') }}
          <div id="menu-icon">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        </div>
        <div class="desktop">       
          <ul>
            <li v-for="(link, text) in $t('menu')" :key="`${text}`" class="nav-item">
              <a :href="`${url}${link}${linkTracker}`" class="nav-link" target="_blank" rel="noopner">{{ text }}</a>
            </li>
          </ul>
          <language-switcher />
        </div>
        <transition name="expand" 
          @enter="enter"
          @after-enter="afterEnter"
          @leave="leave"
          > 
          <div class="collapse-area mobile center" v-if="open">       
            <ul>
              <li v-for="(link, text) in $t('menu')" :key="`${text}`" class="nav-item">
                <a :href="`${url}${link}${linkTracker}`" class="nav-link" target="_blank" rel="noopner">{{ text }}</a>
              </li>
            </ul>
            <language-switcher />
          </div>
        </transition>
      </nav>
      </div>
    </div>
</template>
<script>
import LanguageSwitcher from './LanguageSwitcher.vue';
import consts from '../assets/consts';
export default {
  name: 'Header',
  components: {
    LanguageSwitcher,
  },
  data: function() {
    return {
      www: consts.www,
      url: consts.www,
      langPara: (this.$router.currentRoute.params.lang == 'en' || this.$router.currentRoute.params.lang === 'ja') ? '' : `/${this.$router.currentRoute.params.lang}/`,
      open: false,
      deskhide: true,
      linkTracker: consts.linkTracker
    }
  },
  methods: {
    enter(el) {
      el.style.height = 'auto';
      const height = getComputedStyle(el).height;
      el.style.height = 0;
      getComputedStyle(el);
      setTimeout(() => {
        el.style.height = height;
      })
    },
    afterEnter(el) {
      el.style.height = 'auto';
    },
    leave(el) {
      el.style.height = getComputedStyle(el).height;
      getComputedStyle(el);
      setTimeout(() => {
        el.style.height = 0;
      })
    },
    headerLink: function() {
      `${this.$router.currentRoute.params.lang}` === 'ja' ? this.url = 'https://www.splashtop.co.jp' : this.url = this.www
    }
  },
   created: function() {
     this.headerLink()
  }
}
</script>